import { useContext } from "react";
import GroupContext from "../context/GroupProvider";

const useGroup = () => {
    return useContext(GroupContext);
}

export default useGroup;